import { getDB } from '../../utils/db';

const CACHE_PREFIX = 'institution-dashboard:v1';
const CACHE_TTL_MS = 5 * 60 * 1000;

// A stable non-cryptographic fingerprint keeps the raw bearer token out of
// IndexedDB keys while isolating cached tenant data on shared devices.
const tokenFingerprint = (token) => {
  let hash = 2166136261;
  for (let index = 0; index < token.length; index += 1) {
    hash ^= token.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(36);
};

export const institutionDashboardCacheKey = (token) => (
  token ? `${CACHE_PREFIX}:${tokenFingerprint(token)}` : null
);

export const readInstitutionDashboardCache = async (token) => {
  const key = institutionDashboardCacheKey(token);
  if (!key) return null;
  try {
    const entry = await getDB().get(key);
    return entry?.data || null;
  } catch {
    return null;
  }
};

export const writeInstitutionDashboardCache = async (token, data) => {
  const key = institutionDashboardCacheKey(token);
  if (!key) return;
  try {
    await getDB().set(key, data, { ttl: CACHE_TTL_MS });
  } catch {
    // IndexedDB is an optional performance enhancement; network data remains usable.
  }
};

export const clearInstitutionDashboardCache = async (token) => {
  const key = institutionDashboardCacheKey(token);
  if (!key) return;
  try {
    await getDB().delete(key);
  } catch {
    // A failed cleanup must not block sign-out.
  }
};
